//import { useWhyDidYouUpdate } from 'hooks';
import { getRouteByName } from 'app/routes';
import React from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { useRootStore } from 'store';
import { useTranslation } from 'react-i18next';

import './home-page.css';
import { Link } from '@react-pdf/renderer';
import { WeekRep } from './weekchart';
import { t } from 'i18next';
import { SwitchDashboard } from './dashboard/switch-dashboard';
import { CurrentYearContributions } from './contributions/current-year-contributions';
import { isRebattery, isRebatteryLiion } from 'shared-pages/common/constants';

const HomePage = () => {
  const { appStore, authStore } = useRootStore();
  const history = useHistory();
  const { t, i18n } = useTranslation();
  //-------------------- Body -------------------------------------------
  //

  //-------------------- Handlers -------------------------------------------
  //
  const handleUserClick = () => {
    console.log('handleUserClick', appStore.userLogin);
    history.push(generatePath(getRouteByName('User'), { id: authStore.userId }));
  };
  //
  //-------------------- Render ----------------------------------------------
  //
  if (appStore.isContributor) {
    return (
      <div
        className={
          appStore.isContributor ? 'bg-text bg-text--contributor' : 'bg-text bg-text--welcome-only'
        }
      >
        <div className="home-page-scrollable">
          <div className="slide-up-container">
            <HomeLogoHeader
              t={t}
              i18n={i18n}
              appStore={appStore}
              handleUserClick={handleUserClick}
            />
          </div>

          {/* <Dashboard /> */}

          <div className="home-contributions-stack">
            {(isRebattery || isRebatteryLiion) && (
              <div className="home-contributions-notes" role="note">
                <span className="home-note-item">
                  {t('Πατήστε πάνω στην περίοδο για να μεταφερθείτε στην δήλωση')}
                </span>
                <span className="home-note-item">
                  {t('Μπορείτε να δείτε όλες τις Εισφορές στο μενού "Εισφορές"')}
                </span>
                <span className="home-note-item">
                  {t('Μπορείτε να δημιουργήσετε μία Αναδρομική Δήλωση απο το προφίλ σας')}
                </span>
              </div>
            )}
            <CurrentYearContributions />
            <SwitchDashboard />
          </div>
        </div>
      </div>
    );
  }

  /* DEFAULT RENDER */

  return (
    <div className="bg-text" style={{ padding: '0' }}>
      <div className="home-page-scrollable">
        <div className="slide-up-container">
          <div className="slide-up-context home-header">
            <div className="home-logo-container">
              <img
                alt="Re-Battery Logo"
                src={process.env.PUBLIC_URL + '/logo.png'}
                className="home-logo"
              />
            </div>
            <div className="home-title-container">
              <h1 className="home-title">{t('Ανακύκλωση Μπαταριών')}</h1>
              <p className="home-welcome">{t('Καλώς Ορίσατε στην Εφαρμογή.')}</p>
              <p className="home-user-info">
                {t('Συνδεθήκατε ως Χρήστης')}{' '}
                <strong className="btn-link" onClick={handleUserClick}>
                  {appStore.userLogin.userFirstName + ' ' + appStore.userLogin.userLastName}
                </strong>.
              </p>
            </div>
          </div>
        </div>

        <SwitchDashboard />

        {/* {(appStore.isPlatformOwner || appStore.isCollector || appStore.isCollectorDriver) && (
          <WeekRep />
        )} */}
      </div>
    </div>
  );
};

const HomeLogoHeader = ({ t, i18n, appStore, handleUserClick }) => {
  return (
    <div className="slide-up-context home-welcome-row">
      <div className="home-welcome-logo d-flex align-items-center justify-content-center">
        <img height={108} alt="" src={process.env.PUBLIC_URL + '/logo.png'} className="mx-auto" />
      </div>
      <div className="home-welcome-text mt-4">
        <p>{t('Καλώς Ορίσατε στην Εφαρμογή.')}</p>
        <p>
          {t('Συνδεθήκατε ως Χρήστης')}
          <strong
            className="btn-link"
            // style={{ marginTop: '0', marginBottom: '0.5rem' }}
            onClick={handleUserClick}
          >
            {' ' + appStore.userLogin.userFirstName + ' ' + appStore.userLogin.userLastName}.
          </strong>
        </p>
        {appStore.isContributor && (
          <>
            {' '}
            <p>
              {t('Μπορείτε να δείτε τον οδηγό χρήσης, ')}
              <b>
                <a
                  href={
                    i18n.language === 'gr'
                      ? 'https://re-battery-app-store-pro.s3.eu-west-1.amazonaws.com/resources/%CE%9F%CE%94%CE%97%CE%93%CE%9F%CE%A3+%CE%A7%CE%A1%CE%97%CE%A3%CE%97%CE%A3+%CE%95%CE%A6%CE%91%CE%A1%CE%9C%CE%9F%CE%93%CE%97%CE%A3+RE-BATTERY+APP.pdf'
                      : 'https://re-battery-app-store-pro.s3.eu-west-1.amazonaws.com/resources/%CE%9F%CE%94%CE%97%CE%93%CE%9F%CE%A3+%CE%A7%CE%A1%CE%97%CE%A3%CE%97%CE%A3+%CE%95%CE%A6%CE%91%CE%A1%CE%9C%CE%9F%CE%93%CE%97%CE%A3+RE-BATTERY+APP+EN.pdf'
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('εδώ')}
                </a>
              </b>
            </p>
            <p>{t('Για βοήθεια καλέστε στο 210 5575075')}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default HomePage;
HomePage.whyDidYouRender = true;
